import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import React from "react";

const SolicitudInfo = ({ rowData }) => {
  const rrhh = localStorage.getItem("adminrrhh");
  const user = localStorage.getItem("user");

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "start", // Centra el contenedor horizontalmente
        alignItems: "flex-start", // Asegura que no afecte la posición vertical
        margin: "0 auto", // Alineación horizontal
        width: "100%",
        maxWidth: "1800px", // Tamaño máximo del contenedor
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          backgroundColor: "#f9f9f9", // Fondo claro
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            color: "primary.main",
            fontWeight: "bold",
            textAlign: "start",
          }}
        >
          Detalles de la Solicitud: Puesto {rowData.puesto}
        </Typography>
        <Box>
          <Grid container spacing={2}>
            {(rrhh === "1" || rowData.creador_de_la_solicitud === user) && (
              <>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                    <strong>Para remplazo:</strong>{" "}
                    <span style={{ color: "#555" }}>
                      {rowData.para_remplazo ?? " -"}
                    </span>
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                    <strong>A quien remplaza:</strong>{" "}
                    <span style={{ color: "#555" }}>
                      {rowData.quien_remplaza ?? "-"}
                    </span>
                  </Typography>
                </Grid>
              </>
            )}
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Solicitado por:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {rowData.nombre_creador ?? "-"}{" "}
                  {rowData.apellido_creador ?? "-"}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Candidato seleccionado:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {rowData.candidato_seleccionado ?? "-"}{" "}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Autorizado por:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {rowData.autorizado_por ?? "-"}{" "}
                </span>
              </Typography>
            </Grid>

             <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Entrevista aprobada?:</strong>{" "}
                <span style={{ color: "#555" }}>
               {rowData.aprobadoentrevista === 1 ? "Aprobado" : rowData.aprobadoentrevista == null ? "-": "Rechazado"}
                </span>
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Descripción:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {rowData.descripcion ?? " -"}
                </span>
              </Typography>
            </Grid>

             <Grid item xs={6}>
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                <strong>Evaluaciones médicas aprobada?:</strong>{" "}
                <span style={{ color: "#555" }}>
                {rowData.aprobado_parte_medico === 1 ? "Aprobado" : rowData.aprobado_parte_medico == null ? "-": "Rechazado"}
                </span>
              </Typography>
            </Grid>

          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default SolicitudInfo;
